import { Channel, MerchantStructure } from '@nemuru-eng/js-api-client';

import { ActionsOption } from '../../../../../shared/components/MoreActionsMenu/types/ActionsOption';
import { Text } from '../../../../../shared/components/Text';
import { HeaderCard } from './HeaderCard';

interface ChannelHeaderCard {
  channel: Channel;
  merchantStructure: MerchantStructure;
  redirectPath?: string;
  editModeAllowed?: boolean;
}

export const ChannelHeaderCard = ({
  channel,
  merchantStructure,
  redirectPath,
  editModeAllowed = false,
}: ChannelHeaderCard) => {
  const actions: ActionsOption[] = [
    {
      display: <Text tId={'BLOCK_ALL_USERS'} />,
      iconName: 'lock',
      onClick: () => console.log('hello'),
      disabled: true, //TODO
    },
  ];

  return (
    <HeaderCard
      type={'channel'}
      title={channel.description}
      iconName={'corporate_fare'}
      copyToClipboard={{ value: merchantStructure.merchant.id, textId: 'COPY_MERCHANT_ID' }}
      redirectPath={redirectPath}
      actions={actions}
      editModeAllowed={editModeAllowed}
    />
  );
};
